import React from "react"
import {RouteComponentProps} from "react-router"
import {useTranslation} from "react-i18next"
import {useIonViewWillEnter} from "@ionic/react"

import {useAuth} from "../../contexts/AuthContext"
import {useUsers as useItems} from "../../contexts/UserContext"

import ItemForm from "../../components/Users/Form"
import ItemView from "../../components/Users/View"
import LockingSystemPermissionsList from "../../components/Users/UserLockingSystemPermissions/List"
import PageItem from "../common/Item"
import NotFound from "../../components/Users/NotFound"

interface pageProps extends RouteComponentProps<{
    id:      string;
    segment: string;
}> {}

const PageUsersItem: React.FC<pageProps> = ({ match }) => {
    const { t }        = useTranslation()
    const { fetchItems, items} = useItems()
    const {getMe} = useAuth()

    const
        itemType:     string = 'User',
        itemTypeName: string = t('users.title_item'),
        itemTypeUrl:  string = 'users'

    useIonViewWillEnter(() => {
        // new user form
        if (match.params.id === 'new' && match.params.segment === 'form') {
            getMe().then()
        }
    })

    return (
        <PageItem
            useItems={useItems}
            fetchItems={fetchItems}
            itemId={match.params.id}
            items={items}
            itemType={itemType}
            itemTypeName={itemTypeName}
            itemTypeUrl={itemTypeUrl}
            ItemForm={ItemForm}
            ItemNotFound={NotFound}
            ItemView={ItemView}
            LockingSystemPermissionsList={LockingSystemPermissionsList}
            segment={match.params.segment}
        />
    )
}

export default PageUsersItem